import React, { useEffect } from "react"
import Navbar from "../components/layout/navbar/Navbar"
import Footer from "../components/layout/footer/Footer"
import Sidebar from "../components/layout/sidebar/Sidebar"
import Cart from "../components/module/cart/Cart"
import MiniCart from "../components/module/cart/MiniCart"
import { globalHistory } from "@reach/router"
const Layout = ({ children }) => {
  const [isOpen, setIsOpen] = React.useState(false)
  useEffect(() => {
    return globalHistory.listen(({ action }) => {
      if (action === "PUSH") setIsOpen(false)
    })
  }, [setIsOpen])
  const toggleSidebar = () => {
    setIsOpen(!isOpen)
  }

  return (
    <>
      <Navbar
        toggleSidebar={toggleSidebar}
        setIsOpen={setIsOpen}
        isOpen={isOpen}
      />

      <Cart />
      <Sidebar isOpen={isOpen} />
      <main className="w-full pt-32 min-h-screen">{children}</main>
      <MiniCart />
      <Footer />
    </>
  )
}

export default Layout
